var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showNotification)?_c('b-notification',{attrs:{"type":"is-info"}},[_c('ul',_vm._l((_vm.notificationItemsList),function(item){return _c('li',[_vm._v("\n      "+_vm._s(item)+"\n    ")])}))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }